import React, { ReactElement } from 'react';
import { Content } from './Content';

interface TemporaryAuthPageProps {
  token?: string;
}

function TemporaryAuthPage({ token }: TemporaryAuthPageProps): ReactElement {
  return <Content token={token} />;
}

export { TemporaryAuthPage };
